import daiLoading from "assets/animations/dai-loading.gif";

export default function LoadingLogo() {
  return (
    <div style={{ textAlign: "center" }}>
      <img src={daiLoading} alt="" width="96" height="96" />
    </div>
  );
}
